// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1mY7R","overflowing":"ReadFullNote_overflowing__WiVCR"};